// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g7pK","newExpiryDate":"styles_newExpiryDate__1xP8Y","footer":"styles_footer__2gODp"};